module.exports = __webpack_public_path__ + "assets/Difusor-Aromatico-Cuadrado-06.png";